import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { PRICE } from "../data/offer";
export function GuaranteeSection() {
  return <section className="bg-white px-4 py-16 sm:px-6 sm:py-24" data-id="element-189" data-mp="9uct7c9ulv5a">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-8 text-center md:flex-row md:items-center md:text-left" data-id="element-190" data-mp="9t1lj1da838w">
        <div className="flex h-44 w-44 shrink-0 flex-col items-center justify-center rounded-full bg-navy-900 text-white ring-8 ring-accent-soft" data-id="element-191" data-mp="jsirzl0cyl5x">
          <ShieldCheckIcon className="h-10 w-10 text-cta" aria-hidden="true" data-id="element-192" data-mp="nst7boa1inxg" />
          <span className="font-display text-5xl font-bold leading-none" data-id="element-193" data-mp="skknr5zhfd9v">7</span>
          <span className="font-display text-sm font-semibold uppercase tracking-widest" data-id="element-194" data-mp="xjntksnadniw">Day refund</span>
        </div>
        <div data-id="element-195" data-mp="12jtgjvim2lun">
          <h2 className="font-display text-[2rem] font-bold uppercase leading-[1.08] text-ink sm:text-4xl" data-id="element-196" data-mp="12kbk7d7ls2cl">
            Your 7-day refund policy
          </h2>
          <p className="mt-3 text-lg font-semibold text-navy-700" data-id="element-197" data-mp="25rnioykrkksr">
            Review the material and decide whether it meets your educational needs.
          </p>
          <p className="mt-4 text-base leading-relaxed text-ink-soft" data-id="element-198" data-mp="20rj0930apfzw">
            I want you to understand exactly what you're purchasing before making your decision. You'll be able to
            review the included volumes, checklists, reference materials, and educational exercises.
          </p>
          <p className="mt-4 text-base leading-relaxed text-ink" data-id="element-199" data-mp="2ohn6li4vbtul">
            Your purchase is covered by our seven-day refund policy. If the resource doesn't meet your expectations, you
            may request a refund within seven days of purchase, subject to the terms provided at checkout.
          </p>
        </div>
      </div>
      <div className="mx-auto mt-12 max-w-4xl" data-id="element-200" data-mp="378o0hrr4sz7a">
        <CtaButton label={`Review the offer — $${PRICE}`} data-id="element-201" data-mp="37ah93clb1thx" />
      </div>
    </section>;
}